<!--
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-02-25 10:44:22
 * @LastEditors: scg
 * @Description:
-->
<template>
<div class="fff">
  <div class="Browser_title">{{$t('browser.title')}} </div>
  <div class="Browser_ul">
    <div class="Browser_li" v-for="(val,key) in list" :key="key">
      <img src="@/assets/img/Browser1.png">
      {{val.title}}<span>{{val.url}}</span>
    </div>
  </div>
   <div class="noData" v-if="list.length <= 0 && status">{{$t('browser.tips')}}</div>
    <div class="pagination" v-if="code > 0">
      <el-pagination
        @current-change="setPage"
        background
        page-size="20"
        layout="prev, pager, next"
        :total="code"
      >
      </el-pagination>
    </div>
</div>
</template>

<script>
import {Browserbookmark} from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      key: {
        equipment_id: localStorage.getItem('systemId'),
        page: 1,
        limit: 20
      },
      list: [],
      code: 0,
      msg: '',
      status: false
    }
  },
  mounted () {
    this.getlist()
  },
  methods: {
    setPage (e) {
      this.key.page = e
      this.getlist()
    },
    getlist (a) {
      this.status = false
      Browserbookmark(this.key).then((adj) => {
        this.list = adj.data.list
        this.code = adj.data.count
        this.status = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff{width:97%;margin:20px auto;background:#fff;border-radius:12px;-webkit-box-shadow:0 4px 12px -4px rgba(122,138,153,.2);box-shadow:0 4px 12px -4px rgba(122,138,153,.2);overflow:hidden;}
.Browser_title{line-height:55px;padding-top:10px;height:55px;text-indent:2.5%;font-size:14px;color:#000927;font-weight:700;border-bottom:1px solid #e1e3e6}
.Browser_time{margin-top:20px;line-height:20px;height:20px;font-size:14px;color:#000927;text-indent:2.5%}
.Browser_li{width:95%;margin-left:2.5%;border-bottom:1px solid #e1e3e6;height:60px;line-height:60px;font-size:14px;color:#000927;overflow:hidden}
.Browser_li div{float:left;width:90px;height:60px;line-height:60px;font-size:14px;color:#9f9f9f}
.Browser_li img{float:left;width:20px;height:20px;display:block;margin:20px 10px}
.Browser_li span{margin-left:20px;color:#9f9f9f}

</style>



// WEBPACK FOOTER //
// src/components/Browser.vue